export const environment = {
  name: 'prd',
  production: true,
  enableSentry: true,
  enableAppCheckDebugToken: false,
  appName: 'TRACit',
  features: {
    dashboardPerfLogs: false,
    vault: true,
    mobileActionSheet: false,
    agentDashboardTwoColumn: false,
  },
  firebase: {
    projectId: 'tracit-prd',
    appId: '1:955080046612:web:7fe0e1a3c57ce2443e8f01',
    storageBucket: 'tracit-prd.appspot.com',
    locationId: 'australia-southeast1',
    apiKey: 'AIzaSyDQohohs89HPxBb-p7GnEZUD8Pq1-_etBs',
    // The domain the app is served on, not tracit-prd.firebaseapp.com: Google sign in redirects
    // through <authDomain>/__/auth/handler (Firebase Hosting serves it on any domain of the
    // project) and hands the result back through storage on that domain, which Safari and Firefox
    // partition away when it is a different origin from the app. Changing this needs a matching
    // redirect URI on the Google OAuth client.
    authDomain: 'app.tracit.com.au',
    messagingSenderId: '955080046612',
    measurementId: 'G-Q9XW83W083',
  },
  recaptchaEnterpriseSiteKey: '6LccDIotAAAAAIoRPZvX8-M1RqonBPfeCI1EdsQe',
  // Reached with a plain fetch, never through a Firebase SDK: it is the endpoint
  // we call precisely when the browser has failed to mint an App Check token, so
  // whatever blocked that would very likely block an SDK call too. Already
  // covered by the connect-src in firebase.json.
  appCheckFailureLogUrl: 'https://australia-southeast1-tracit-prd.cloudfunctions.net/logAppCheckFailure',
  publicAssetsBaseUrl: 'https://storage.googleapis.com/tracit-prd-public-assets',
  auth: {
    googleSso: {
      enabled: true,
      allowedDomains: ['tracit.com.au'],
    },
  },
  searchIndexes: {
    agents: 'prd_AGENTS',
    groups: 'prd_GROUPS',
    trainers: 'prd_TRAINERS',
  },
  stripePublishableKey: 'pk_live_51HjZ0nFqPSGzIl2TkFZPGw0QL4coXaqvS4CT2j9Z1PQ2QrSLUb1vm5WmBnm20pmmQ0aWupAG3cyCNYyKVUGAfKdb00SIrhyD7l',
  subscriptions: {
    individual: 33,
    office: 36,
  },
  rolesFallbackPrice: 36,
  roles: [
    {
      group: "Licensed Real Estate Agents",
      roles: [
        {
          key: "agent-sales",
          value: "Agent - Sales",
          price: 36,
        },
        {
          key: "agent-pm",
          value: "Agent - Property Management",
          price: 36,
        },
        {
          key: "buyers-agent",
          value: "Buyers Agent",
          price: 46,
        },
        {
          key: "commercial-agent",
          value: "Commercial Agent",
          price: 56,
        },
        {
          key: "lic",
          value: "Licensee in Charge",
          price: 36,
        },
        {
          key: "support",
          value: "Support (Licensed)",
          price: 36,
        },
      ],
    },

    {
      group: "Contractors",
      roles: [
        {
          key: "independent-contractor-sales",
          value: "Independent Contractor - Sales",
          price: 46,
        },
      ],
    },

    {
      group: "Support Staff (Non-Licensed)",
      roles: [
        {
          key: "support-sales",
          value: "Support – Sales (Non-Licensed)",
          price: 0,
        },
        {
          key: "support-pm",
          value: "Support – Property Management (Non-Licensed)",
          price: 0,
        },
        {
          key: "employee",
          value: "Employee (Non-Licensed)",
          price: 0,
        },
        {
          key: "admin",
          value: "Office Administrator",
          price: 0,
        },
        {
          key: "support-other",
          value: "Other (Non-Licensed)",
          price: 0,
        },
      ],
    },

    {
      group: "Other",
      roles: [
        {
          key: "other",
          value: "Other",
          price: 36,
        },
      ],
    },
  ],
};
